import React from "react";
import "./CustomTabs.css";

const TabCaption = ({ tab }) => {
  const title = tab?.label ?? "";
  const amount = tab?.amount;
  const hasAmount =
    amount != null && amount !== "" && Number.isFinite(Number(amount));

  if (!hasAmount) {
    return <span>{title}</span>;
  }

  const amountText =
    tab.amountLabel ||
    `Rs ${Math.round(Number(amount)).toLocaleString("en-PK")}`;

  return (
    <span className="tab-label-stack">
      <span className="tab-label-title">{title}</span>
      <span className="tab-label-amount">{amountText}</span>
    </span>
  );
};

const CustomTabs = ({ tabs, activeTab, setActiveTab, scrollable = false }) => {
  const safeTabsCount = tabs.length > 0 ? tabs.length : 1;
  const clampedActiveIndex = Math.min(Math.max(activeTab, 0), safeTabsCount - 1);

  if (scrollable) {
    return (
      <div className="w-full h-fit font-quicksand">
        {/* Mobile — scrollable pill tabs */}
        <div className="custom-tabs-mobile max850:block hidden">
          <div className="custom-tabs-mobile-scroll">
            {tabs.map((tab, index) => {
              const active = index === activeTab;
              return (
                <button
                  key={tab.label || index}
                  type="button"
                  onClick={() => setActiveTab(index)}
                  className={`custom-tabs-mobile-pill${active ? " is-active" : ""}`}
                >
                  <TabCaption tab={tab} />
                </button>
              );
            })}
          </div>
        </div>

        {/* Desktop — segmented control */}
        <div className="custom-tabs-desktop max850:hidden">
          <DesktopTabs
            tabs={tabs}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            safeTabsCount={safeTabsCount}
            clampedActiveIndex={clampedActiveIndex}
          />
        </div>
      </div>
    );
  }

  return (
    <DesktopTabs
      tabs={tabs}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      safeTabsCount={safeTabsCount}
      clampedActiveIndex={clampedActiveIndex}
    />
  );
};

const DesktopTabs = ({
  tabs,
  activeTab,
  setActiveTab,
  safeTabsCount,
  clampedActiveIndex,
}) => (
  <div className="w-full h-fit">
    <input type="checkbox" id="theme-mode" className="mode appearance-none" />

    <div className="container">
      <div
        className="wrap"
        style={{
          "--tabs-count": safeTabsCount,
          "--active-index": clampedActiveIndex,
        }}
      >
        {tabs.map((tab, index) => (
          <React.Fragment key={index}>
            <input
              type="radio"
              id={`rd-${index + 1}`}
              name="radio"
              className={`rd-${index + 1}`}
              checked={index === activeTab}
              onChange={() => setActiveTab(index)}
              hidden
            />
            <label htmlFor={`rd-${index + 1}`} className="label">
              <TabCaption tab={tab} />
            </label>
          </React.Fragment>
        ))}

        <div className="bar"></div>
        <div className="slidebar"></div>
      </div>
    </div>
  </div>
);

export default CustomTabs;
